import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ITEM_TEXT_DELIMITER_TYPE } from '@Services/Editor/Constants';

import TX from '@Components/Common/Text';

const ItemCell = ({ name, selectedItemName, addToItemSellRefs, handleItemCellClick }) => {
  const isSelected = name === selectedItemName;
  const splittedHiddenItemName = name.split(ITEM_TEXT_DELIMITER_TYPE.HIDDEN_ITEM)[1];
  const isHiddenItem = splittedHiddenItemName && splittedHiddenItemName.length;

  return (
    <ItemCellContainer
      id={name}
      ref={addToItemSellRefs}
      isSelected={isSelected}
      onClick={event => handleItemCellClick(event, name)}
    >
      {isHiddenItem ? (
        <ItemNameTextContainer>
          <ItemNameText isGray>{ITEM_TEXT_DELIMITER_TYPE.HIDDEN_ITEM}</ItemNameText>
          <ItemNameText>{splittedHiddenItemName}</ItemNameText>
        </ItemNameTextContainer>
      ) : (
        <ItemNameText>{name}</ItemNameText>
      )}
    </ItemCellContainer>
  );
};

ItemCell.propTypes = {
  name: PropTypes.string.isRequired,
  selectedItemName: PropTypes.string.isRequired,
  addToItemSellRefs: PropTypes.func.isRequired,
  handleItemCellClick: PropTypes.func.isRequired,
};

const ItemCellContainer = styled.div`
  padding: 6px;

  cursor: pointer;
  border-radius: 4px;
  background-color: ${({ isSelected, theme }) => isSelected && theme.colors.ui_3};
`;

const ItemNameTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ItemNameText = styled(TX.FootnoteM)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  color: ${({ theme, isGray }) => (isGray ? theme.colors.ui_on_3 : theme.colors.ui_on_1)};
`;

export default ItemCell;
